import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
    >
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        {/* Badge */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8"
        >
          <Sparkles className="w-4 h-4 text-[#4facfe]" />
          <span className="text-white/70 text-sm font-medium">
            Innovation & Excellence
          </span>
        </motion.div>

        {/* Main Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-outfit text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black tracking-tighter text-white mb-6"
        >
          Créons ensemble
          <br />
          <span className="text-gradient">l'avenir numérique</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-white/70 text-base sm:text-lg lg:text-xl max-w-2xl mx-auto mb-10 leading-relaxed font-inter"
        >
          Solutions web et mobiles sur mesure pour entreprises ambitieuses. 
          Du concept à la réalisation, nous transformons vos idées en expériences numériques exceptionnelles.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <motion.button
            data-testid="cta-hero-button"
            className="group flex items-center gap-2 bg-gradient-to-r from-[#00f2fe] to-[#4facfe] text-white font-semibold rounded-lg px-8 py-4 text-base hover:opacity-90 transition-all shadow-[0_0_20px_rgba(79,172,254,0.4)]"
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(79, 172, 254, 0.5)' }}
            whileTap={{ scale: 0.98 }}
          >
            Commencer un projet
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </motion.button>
          
          <motion.a
            href="#portfolio"
            className="flex items-center gap-2 text-white/80 hover:text-white font-medium px-8 py-4 rounded-lg border border-white/20 hover:border-white/40 transition-all"
            whileHover={{ scale: 1.02 }}
          >
            Voir nos réalisations
          </motion.a>
        </motion.div>

        {/* Stats */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto"
        >
          {[
            { value: '50+', label: 'Projets livrés' },
            { value: '98%', label: 'Clients satisfaits' },
            { value: '5+', label: 'Années d\'expérience' },
            { value: '24/7', label: 'Support technique' },
          ].map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 1 + index * 0.1 }}
              className="text-center"
            >
              <div className="font-outfit text-3xl sm:text-4xl font-bold text-gradient mb-2">
                {stat.value}
              </div>
              <div className="text-white/50 text-sm">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#080410] to-transparent pointer-events-none" />
    </section>
  );
};

export default Hero;
